import React from "react";
import { SkeletonBox, SkeletonText, SkeletonCard, SkeletonChip } from "./SkeletonBox";

/**
 * ShowcasePageSkeleton - Non-animated skeleton for showcase pages
 * (Movie Home, Series Home, Anavatan)
 * 
 * These pages have:
 * - No hero slider
 * - Multiple content rows with movie cards
 * - Optional header (Anavatan has city selector)
 */

function skeletonElement(className) {
  return function SkeletonElement(props) {
    var mergedClassName = className + (props.className ? " " + props.className : "");
    return <div {...props} className={mergedClassName} />;
  };
}

var ContentWrapper = skeletonElement("legacy-skeleton-showcase-content");
var ScrollingRows = skeletonElement("legacy-skeleton-showcase-scroll");
var ContentRowWrapper = skeletonElement("legacy-skeleton-row");
var RowTitle = skeletonElement("legacy-skeleton-row-title legacy-skeleton-row-title-top");
var CardsContainer = skeletonElement("legacy-skeleton-cards");
var CardWrapper = skeletonElement("legacy-skeleton-card-wrap");
var HeaderSection = skeletonElement("legacy-skeleton-showcase-header");
var HeaderRow = skeletonElement("legacy-skeleton-inline-row legacy-skeleton-showcase-header-row");
var CityChipsRow = skeletonElement("legacy-skeleton-wrap-row");
var ChipWrapper = skeletonElement("legacy-skeleton-chip-wrap");

/**
 * Content Row Skeleton (reusable)
 */
function ContentRowSkeleton({ cardType = "portrait", cardCount = 6 }) {
  var cards = [];
  for (var i = 0; i < cardCount; i++) {
    cards.push(
      <CardWrapper key={"card_" + i}>
        <SkeletonCard type={cardType} />
      </CardWrapper>
    );
  }

  return (
    <ContentRowWrapper>
      <RowTitle />
      <CardsContainer>
        {cards}
      </CardsContainer>
    </ContentRowWrapper>
  );
}

/**
 * Anavatan Header Skeleton (city selector)
 */
function AnavatanHeaderSkeleton() {
  var chips = [];
  var widths = [80, 100, 90, 110, 85, 95, 100, 80];

  for (var i = 0; i < 8; i++) {
    chips.push(
      <ChipWrapper key={"city_" + i}>
        <SkeletonChip width={widths[i]} />
      </ChipWrapper>
    );
  }

  return (
    <HeaderSection>
      <HeaderRow>
        <SkeletonText width={180} size="xl" style={{ marginLeft: 20 }} />
        <SkeletonBox width={40} height={40} borderRadius={8} />
      </HeaderRow>
      <CityChipsRow>
        {chips}
      </CityChipsRow>
    </HeaderSection>
  );
}

/**
 * ShowcasePageSkeleton - Main export
 * @param {boolean} showHeader - Show Anavatan-style header
 * @param {number} rowCount - Number of content rows to show
 */
function ShowcasePageSkeleton({ showHeader = false, rowCount = 4 }) {
  var rows = [];
  for (var i = 0; i < rowCount; i++) {
    rows.push(
      <ContentRowSkeleton
        key={"row_" + i}
        cardType="portrait"
        cardCount={6}
      />
    );
  }

  return (
    <ContentWrapper>
      <ScrollingRows>
        {showHeader && <AnavatanHeaderSkeleton />}
        {rows}
      </ScrollingRows>
    </ContentWrapper>
  );
}

export { ContentRowSkeleton, AnavatanHeaderSkeleton };
export default ShowcasePageSkeleton;
